import { FormEventHandler } from "react";

import { Ds } from "@accurx/design";

import { ManageTemplatesFormHook } from "../../ManageTemplatesFormPage.types";

export type CategoryModalProps = {
    handleCloseModal: () => void;
    handleAddCategory: FormEventHandler;
    isModalOpen: boolean;
    formValues: ManageTemplatesFormHook["addCategoryFormValues"];
    onChange: ManageTemplatesFormHook["addCategoryFormOnChange"];
    errors: ManageTemplatesFormHook["addCategoryFormErrors"];
};

export const CategoryModal = ({
    handleCloseModal,
    handleAddCategory,
    isModalOpen,
    formValues,
    onChange,
    errors,
}: CategoryModalProps): JSX.Element => {
    const categoryErrors = errors.newCategoryName.filter((error) => error);

    return (
        <Ds.Modal open={isModalOpen} onOpenChange={handleCloseModal}>
            <Ds.Modal.Section>
                <Ds.Flex
                    justifyContent="space-between"
                    alignItems="center"
                    gap="2"
                >
                    <Ds.Modal.Title>Add category</Ds.Modal.Title>
                    <Ds.Modal.CloseButton aria-label="Close" />
                </Ds.Flex>
            </Ds.Modal.Section>
            <Ds.Modal.Divider />

            <Ds.Form onSubmit={handleAddCategory}>
                <Ds.Modal.Section>
                    <Ds.Form.Field name="category-name">
                        <Ds.Form.Label>New category name</Ds.Form.Label>
                        <Ds.Form.Description>
                            This will organise templates in the dropdown. Create
                            subfolders by separating category names with a
                            forward slash "/"
                        </Ds.Form.Description>
                        <Ds.Form.Control>
                            <Ds.TextInput
                                id="new-category-input"
                                placeholder="Write new category"
                                value={formValues.newCategoryName}
                                onChange={onChange.newCategoryName}
                                isInvalid={categoryErrors.length > 0}
                            />
                        </Ds.Form.Control>
                        {categoryErrors.map((error) => (
                            <Ds.Form.Error key={error}>{error}</Ds.Form.Error>
                        ))}
                    </Ds.Form.Field>
                </Ds.Modal.Section>
                <Ds.Modal.Divider />
                <Ds.Modal.Section>
                    <Ds.Flex justifyContent="flex-end" gap="1">
                        <Ds.Button
                            appearance="secondary"
                            onClick={handleCloseModal}
                        >
                            Cancel
                        </Ds.Button>
                        <Ds.Form.Submit aria-label="Save category">
                            Save
                        </Ds.Form.Submit>
                    </Ds.Flex>
                </Ds.Modal.Section>
            </Ds.Form>
        </Ds.Modal>
    );
};
